// extracted by mini-css-extract-plugin
export default {"container":"ReceiptDialog_container__EWUyE","image":"ReceiptDialog_image__3Mfse"};